/**=========================================================
 * Module: gcp.js
 * GCP Controller
 =========================================================*/

App.controller('GcpController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'DataService',
        function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, D) {
            "use strict";

            function dashedToPascalCase(str) {
                const words = str.split('-');
                const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
                return capitalizedWords.join('');
              }


            let unwatch = $rootScope.$watch('user.id', function(){  
                if($rootScope.user.id){
                    unwatch();
                    $scope.page = {
                        title: 'GCP',
                        subTitle: dashedToPascalCase($state.params.action) 
                    }

                    if($state.params.action=='firestore'){

                        $scope.model = {};
                        $scope.activeFields = {}
                        $scope.type = $state.params.filter ? $state.params.filter.split(':')[0] : '';
                        $scope.id = $state.params.filter ? $state.params.filter.split(':')[1] : '';

                        function flattenObject(obj, prefix = '') {
                            return Object.keys(obj).sort().reduce((acc, key) => {
                            const pre = prefix.length ? prefix + '.' : '';
                            if (typeof obj[key] === 'object' && obj[key] !== null) {
                                Object.assign(acc, flattenObject(obj[key], pre + key));
                            } else {
                                acc[pre + key] = { value: obj[key], type: typeof obj[key] };
                            }
                            return acc;
                            }, {});
                        }


                        $scope.form = {
                            title: '',
                            status: '',
                            type: 'gcp',
                            model: { service: 'firestore', type: $scope.type, id: $scope.id },
                            fields: [{
                                available: true,
                                type: 'select',
                                name: 'type',
                                data: [
                                    { key: 'Account' },
                                    { key: 'ActionLog' },
                                    { key: 'Analysis' },
                                    { key: 'Counter' },
                                    { key: 'EmailLog' },
                                    { key: 'ExchangeRate' },
                                    { key: 'File' },
                                    { key: 'Group' },
                                    { key: 'HashKey' },
                                    { key: 'InboundEmail' },
                                    { key: 'Message' },
                                    { key: 'Offer' },
                                    { key: 'Order' },
                                    { key: 'Packet' },
                                    { key: 'Price' },
                                    { key: 'Project' },
                                    { key: 'Property' },
                                    { key: 'Reference' },
                                    { key: 'Session' },
                                    { key: 'Stat' },
                                    { key: 'StatData' },
                                    { key: 'SuperGroup' },
                                    { key: 'TaskResult' },
                                    { key: 'Template' },
                                    { key: 'TestEntity' },
                                    { key: 'TM' },
                                    { key: 'Tooltip' },
                                    { key: 'Translation' },
                                    { key: 'Translator' },
                                    { key: 'Wait' }
                                ],
                                valueField: 'key',
                                labelField: 'key',
                                required: true
                            }, {
                                available: true,
                                type: 'text',
                                name: 'id',
                                required: true
                            }, {

                            },{
                                available: true,
                                type: 'submit',
                                name: 'submit'
                            }],
                            submit: function () {
                                $scope.form.status = 'submitting';
                                if($scope.form.model.id){
                                    D.load('gcp', $scope.form.model.service + ':' + $scope.form.model.type + ':' + $scope.form.model.id).then(function (response) {
                                        $scope.form.status = 'submitted';
                                        $scope.model.data = flattenObject(response.data.data)
                                        $scope.model.search = flattenObject(response.data.search)
                                        $scope.model.log = response.data._log
                                        $scope.model.type = $scope.form.model.type;
                                        $scope.model.id = $scope.form.model.id;
                                    }).catch(function (response) {
                                        $scope.form.status = 'error';
                                        $scope.model = response;
                                    });
                                }
                            }
                        }

                        $scope.save = function(){
                            let obj = {}
                            for(let k of Object.keys($scope.activeFields)){
                                if($scope.activeFields[k]){
                                    if($scope.model.data[k].type=='number'){
                                        $scope.model.data[k].value = parseFloat($scope.model.data[k].value)
                                    }
                                    obj['data.'+k] = $scope.model.data[k].value
                                }
                            }
                            D.save('gcp', { service: 'firestore', id: 'UpdateData', _type: $scope.model.type, _id: $scope.model.id, data: obj }).then(function (response) {

                            }).catch(function (err) {

                            });
                        }
                    }

                    if($state.params.action=='api'){
                        $scope.apiForm = {
                            title: 'API',
                            status: '',
                            type: 'gcp',
                            model: { },
                            fields: [
                                {
                                    available: true,
                                    type: 'select',
                                    name: 'method',
                                    data: [
                                        { key: 'GET' },
                                        { key: 'POST' },
                                        { key: 'PUT' },
                                        { key: 'DELETE' }
                                    ],
                                    valueField: 'key',
                                    labelField: 'key',
                                    required: true
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'type',
                                    required: true
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'id',
                                    required: true
                                },
                                {
                                    available: true,
                                    type: 'textarea',
                                    name: 'body'
                                },
                                {
                                    available: true,
                                    type: 'submit',
                                    name: 'submit'
                                }
                            ],
                            submit: function () {
                                $scope.apiForm.status = 'submitting';
                                if(this.model.method=='PUT'){
                                    R.one(this.model.type, this.model.id).customPUT(JSON.parse(this.model.body)).then(function (response) {
                                        $scope.apiForm.status = 'submitted';
                                        $scope.apiForm.response = JSON.stringify(response.data, null, 2);
                                    }).catch(function (response) {
                                        $scope.apiForm.status = 'error';
                                        $scope.apiForm.response = JSON.stringify(response, null, 2);
                                    });
                                }
                                if(this.model.method=='POST'){
                                    R.one(this.model.type).customPOST(JSON.parse(this.model.body)).then(function (response) {
                                        $scope.apiForm.status = 'submitted';
                                        $scope.apiForm.response = JSON.stringify(response.data, null, 2);
                                    }).catch(function (response) {
                                        $scope.apiForm.status = 'error';
                                        $scope.apiForm.response = JSON.stringify(response, null, 2);
                                    });
                                }
                                if(this.model.method=='GET'){
                                    R.one(this.model.type, this.model.id).get().then(function (response) {
                                        $scope.apiForm.status = 'submitted';
                                        $scope.apiForm.response = JSON.stringify(response.data, null, 2);
                                    }).catch(function (response) {
                                        $scope.apiForm.status = 'error';
                                        $scope.apiForm.response = JSON.stringify(response, null, 2);
                                    });
                                }
                                if(this.model.method=='DELETE'){
                                    R.one(this.model.type, this.model.id).remove().then(function (response) {
                                        $scope.apiForm.status = 'submitted';
                                        $scope.apiForm.response = JSON.stringify(response.data, null, 2);
                                    }).catch(function (response) {
                                        $scope.apiForm.status = 'error';
                                        $scope.apiForm.response = JSON.stringify(response, null, 2);
                                    });
                                }
                            }
                        }
                    }

                    if($state.params.action=='storage'){

                        D.query('storage', '').then(function (response) {
                            $scope.data = response
                        }).catch(console.error);

                    }

                    if($state.params.action=='tasks'){
                        D.load('gcp', 'queues').then(function (response) {
                            $scope.data = response.data
                        }).catch(console.error);
                    }

                    if($state.params.action=='postmark'){
                        D.query('template','', { cache: false }).then(function (response) {
                            $scope.headers = []
                            $scope.footers = []
                            $scope.templates = []
                            for(let i=0; i<response.length; i++){
                                response[i].name = response[i].template + ' (' + response[i].language + ')'
                                if(response[i].id.startsWith('_header')){
                                    $scope.headers.push(response[i])
                                } else if(response[i].id.startsWith('_footer')){
                                    $scope.footers.push(response[i])
                                } else {
                                    $scope.templates.push(response[i])
                                }
                                
                            }
                            $scope.templates.push({ id: '*', name: '*' })

                            $scope.updateBody = function(){
                                $scope.postmarkForm.model.body = $scope.headers.find(function(e){ return e.id==$scope.postmarkForm.model.header }).html
                                    + ($scope.postmarkForm.model.template=='*' ? 
                                        $scope.templates.map(function(e){ return e.html }).join('<hr>')
                                        : $scope.templates.find(function(e){ return e.id==$scope.postmarkForm.model.template }).html)
                                    + $scope.footers.find(function(e){ return e.id==$scope.postmarkForm.model.footer }).html
                            }

                            $scope.postmarkForm = {
                                title: 'Send email',
                                status: '',
                                type: 'gcp',
                                model: { id: 'SendEmail', service: 'postmark'  },
                                fields: [
                                    {
                                        available: true,
                                        type: 'select',
                                        name: 'header',
                                        data: $scope.headers,
                                        valueField: 'id',
                                        labelField: 'name',
                                        onchange: function(){
                                            $scope.updateBody()
                                        }
                                    },{
                                        available: true,
                                        type: 'select',
                                        name: 'template',
                                        data: $scope.templates,
                                        valueField: 'id',
                                        labelField: 'name',
                                        onchange: function(){
                                            $scope.postmarkForm.model.subject = $scope.templates.find(function(e){ return e.id==$scope.postmarkForm.model.template }).subject
                                            $scope.postmarkForm.model.action = $scope.templates.find(function(e){ return e.id==$scope.postmarkForm.model.template }).action
                                            $scope.postmarkForm.model.link = $scope.templates.find(function(e){ return e.id==$scope.postmarkForm.model.template }).link
                                            $scope.updateBody()
                                        }
                                    },{
                                        available: true,
                                        type: 'select',
                                        name: 'footer',
                                        data: $scope.footers,
                                        valueField: 'id',
                                        labelField: 'name',
                                        onchange: function(){
                                            $scope.updateBody()
                                        }
                                    },{
                                        available: true,
                                        type: 'text',
                                        name: 'to'
                                    },{
                                        available: true,
                                        type: 'text',
                                        name: 'subject'
                                    },{
                                        available: true,
                                        type: 'editor',
                                        name: 'body'
                                    },{
                                        available: true,
                                        type: 'text',
                                        name: 'action'
                                    },{
                                        available: true,
                                        type: 'text',
                                        name: 'link'
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'submit',
                                        label: 'Send'
                                    }
                                ],
                                submit: function () {
                                    $scope.postmarkForm.status = 'submitting';
                                    D.save('gcp', $scope.postmarkForm.model).then(function (response) {
                                        $scope.postmarkForm.status = 'submitted';
                                    }).catch(function (response) {
                                        $scope.postmarkForm.status = 'error';
                                    })
                                }
                            }
                        }).catch(console.error);

                        

                    }

                    if($state.params.action=='logs'){

                        $scope.logsForm = {
                            title: 'Logs',
                            status: '',
                            type: 'gcp',
                            model: { service: 'logs', type: '', name: '' },
                            fields: [
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'name',
                                    label: 'Log name'
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'type',
                                    label: 'Reource type'
                                },
                                {
                                    available: true,
                                    type: 'select',
                                    name: 'severity',
                                    label: 'Severity',
                                    data: [
                                        { key: 'DEBUG' },
                                        { key: 'INFO' },
                                        { key: 'NOTICE' },
                                        { key: 'WARNING' },
                                        { key: 'ERROR' },
                                        { key: 'CRITICAL' },
                                        { key: 'ALERT' },
                                        { key: 'EMERGENCY' }
                                    ],
                                    valueField: 'key',
                                    labelField: 'key',
                                }, {
                                    available: true,
                                    type: 'text',
                                    name: 'limit',
                                    label: 'Limit'
                                },{
                                    available: true,
                                    type: 'text',
                                    name: 'days',
                                    label: 'Days'
                                },{
                                    available: true,
                                    type: 'text',
                                    name: 'date',
                                    label: 'Date'
                                },{
                                    available: true,
                                    type: 'text',
                                    name: 'search',
                                    label: 'Search'
                                },{
                                    available: true,
                                    type: 'submit',
                                    name: 'submit'
                                }
                            ],
                            submit: function () {

                                $scope.loading = true;
                                let options = ($scope.logsForm.model.severity ? 'severity=' + $scope.logsForm.model.severity : '')
                                options += ($scope.logsForm.model.limit ? '&limit=' + $scope.logsForm.model.limit : '')
                                options += ($scope.logsForm.model.days ? '&days=' + $scope.logsForm.model.days : '')
                                options += ($scope.logsForm.model.search ? '&search=' + $scope.logsForm.model.search : '')
                                options += ($scope.logsForm.model.date ? '&date=' + $scope.logsForm.model.date : '')
                                options += ($scope.logsForm.model.type ? '&type=' + $scope.logsForm.model.type : '')
                                D.load('gcp', 'logs:' + $scope.logsForm.model.name + ':' + options).then(function (response) {
                                    $scope.loading = false;
                                    $scope.logs = {}
                                    for(let i in response.data.logEntries){
                                        let e = response.data.logEntries[i]
                                        if(!$scope.logs[e.message || e._]){
                                            $scope.logs[e.message || e._] = []
                                        }
                                        $scope.logs[e.message || e._].push(e)
                                    }
                                    //order $scope.logs by length of arrays
                                    $scope.logs = Object.keys($scope.logs).sort(function(a,b){ return $scope.logs[b].length - $scope.logs[a].length }).reduce((r, k) => (r[k] = $scope.logs[k], r), {});
                                }).catch(console.error);
                            }
                        }
                    }

                    if($state.params.action=='restore'){

                        $scope.loadRestore = function(){
                            FIREBASE.read(['restore', $scope.sourceFolder,'result'], function(data){
                                $timeout(function() { $scope.collections = data }, 0);

                                FIREBASE.read(['restore', $scope.sourceFolder,'errors'], function(data){
                                    $timeout(function() { 
                                        for(let k in data){
                                            let c = data[k].Id.split('-')[0]
                                            let errors = $scope.collections.find(function(e){ return e.Id==c }).errors
                                            if(!errors){
                                                errors = []
                                            }
                                            errors.push(data[k])
                                            $scope.collections.find(function(e){ return e.Id==c }).errors = errors 
                                        }
                                    }, 0);
                                })

                            }, function(err){

                            }, {keepOnListening:true})
                        }

                        $scope.restoreForm = {
                            title: 'Restore data',
                            status: '',
                            type: 'data',
                            model: {
                                "skipCheck": true,
                                "startFrom": 0,
                                "sourceFolder": $scope.sourceFolder,
                                "limit": 0,
                                "queueNext": true,
                                "type": '',
                                "onlyId": "",
                                "onlyAfterTimestamp": 0,
                                "startFromId": ""
                            },
                            fields: [{
                                available: true,
                                type: 'select',
                                name: 'type',
                                data: [
                                    { key: 'Account' },
                                    { key: 'ActionLog' },
                                    { key: 'Analysis' },
                                    { key: 'Counter' },
                                    { key: 'EmailLog' },
                                    { key: 'ExchangeRate' },
                                    { key: 'File' },
                                    { key: 'Group' },
                                    { key: 'HashKey' },
                                    { key: 'InboundEmail' },
                                    { key: 'Message' },
                                    { key: 'Offer' },
                                    { key: 'Order' },
                                    { key: 'Packet' },
                                    { key: 'Price' },
                                    { key: 'Project' },
                                    { key: 'Property' },
                                    { key: 'Reference' },
                                    { key: 'Session' },
                                    { key: 'Stat' },
                                    { key: 'StatData' },
                                    { key: 'SuperGroup' },
                                    { key: 'TaskResult' },
                                    { key: 'Template' },
                                    { key: 'TestEntity' },
                                    { key: 'TM' },
                                    { key: 'Tooltip' },
                                    { key: 'Translation' },
                                    { key: 'Translator' },
                                    { key: 'Wait' }
                                ],
                                valueField: 'key',
                                labelField: 'key',
                                required: true
                            }, {
                                available: true,
                                type: 'text',
                                name: 'sourceFolder'
                            }, {
                                available: true,
                                type: 'text',
                                name: 'onlyId'
                            },{
                                available: true,
                                type: 'text',
                                name: 'onlyAfterTimestamp'
                            },{
                                available: true,
                                type: 'text',
                                name: 'startFromId'
                            },{
                                available: true,
                                type: 'text',
                                name: 'startFrom'
                            },{
                                available: true,
                                type: 'text',
                                name: 'limit'
                            },{
                                available: true,
                                type: 'checkbox',
                                name: 'skipCheck'
                            },{
                                available: true,
                                type: 'checkbox',
                                name: 'queueNext'
                            },{
                                available: true,
                                type: 'submit',
                                name: 'submit'
                            }],
                            submit: function () {
                                $scope.restoreForm.status = 'submitting';
                                R.one('data', 'Restore').customPUT($scope.restoreForm.model).then(function (response) {
                                    $scope.restoreForm.status = 'submitted';
                                }).catch(function (response) {
                                    $scope.restoreForm.status = 'error';
                                })
                            }
                        }

                    }

                }
            })
        }
    ]);